import { REMOVE_LINE, REMOVE_LINE_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const removeLineAction = (params) => async (dispatch) => {
  const { legal_id, order_id, direct_number } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.delete(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/lines/${direct_number}`,
      {
        data: {},
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    const { data, status } = response || {};

    dispatch({
      method: 'delete',
      payload: data || {},
      status: status || {},
      type: REMOVE_LINE,
    });
  } catch (e) {
    dispatch({
      method: 'delete',
      payload: e || {},
      type: REMOVE_LINE_ERROR,
    });
  }
};
